/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { StreamerBoxStreamerBoxDeviceVarsListQueryResponse, StreamerBoxStreamerBoxDeviceVarsListPathParams } from "../models/StreamerBoxStreamerBoxDeviceVarsList";

export function getStreamerBoxStreamerBoxDeviceVarsListUrl(uuidOrId: StreamerBoxStreamerBoxDeviceVarsListPathParams["uuidOrId"]) {
  const res = { method: 'GET', url: `/streamer-box/devices/${uuidOrId}/vars` as const }
  return res
}

/**
 * @description Returns public device variables (`PUBLIC_*` prefix stripped from names).
 * @summary List device variables
 * {@link /streamer-box/devices/:uuidOrId/vars}
 */
export async function streamerBoxStreamerBoxDeviceVarsList(uuidOrId: StreamerBoxStreamerBoxDeviceVarsListPathParams["uuidOrId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<StreamerBoxStreamerBoxDeviceVarsListQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getStreamerBoxStreamerBoxDeviceVarsListUrl(uuidOrId).url.toString(), ... requestConfig })
  return res.data
}